{
  "tabs": {
    "chat": "စကားပြော",
    "reminders": "မှတ်တမ်းများ",
    "calendar": "ပြက္ခဒိန်",
    "settings": "ဆက်တင်များ"
  },
  "common": {
    "cancel": "မလုပ်တော့ပါ",
    "save": "သိမ်းမည်",
    "confirm": "အတည်ပြုမည်",
    "delete": "ဖျက်မည်",
    "back": "နောက်သို့",
    "close": "ပိတ်မည်",
    "edit": "ပြင်ဆင်မည်",
    "search": "ရှာဖွေမည်",
    "all": "အားလုံး",
    "loading": "ဖတ်နေသည်...",
    "error": "တစ်ခုခုမှားယွင်းနေသည်",
    "notFound": "မတွေ့ပါ",
    "tryAgain": "ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ",
    "retry": "ထပ်မံကြိုးစားမည်",
    "undo": "မလုပ်ခဲ့ပါ",
    "pullToRefresh": "ဆွဲပြီး ပြန်လည်အသစ်ပြုလုပ်ရန်",
    "justNow": "ခုနက"
  },
  "auth": {
    "welcome": "FishMemory သို့ ကြိုဆိုပါသည်",
    "tagline": "သင့် WhatsApp မှတ်တမ်းအကူအညီ၊ ယခု သင့်အိတ်ထဲတွင်ရှိသည်။",
    "subtitle": "သင့် WhatsApp မှတ်တမ်းအကူအညီ၊ ယခု သင့်အိတ်ထဲတွင်ရှိသည်။",
    "phoneLabel": "သင့် WhatsApp နံပါတ်",
    "phoneHint": "WhatsApp မှတဆင့် အတည်ပြုကုဒ် ပေးပို့ပါမည်",
    "invalidPhone": "မှန်ကန်သော ဖုန်းနံပါတ် ထည့်ပါ",
    "continue": "ဆက်လက်လုပ်ဆောင်မည်",
    "enterPhone": "သင့် WhatsApp နံပါတ် ထည့်ပါ",
    "phonePlaceholder": "ဖုန်းနံပါတ်",
    "sendCode": "ကုဒ်ပို့မည်",
    "verifyTitle": "သင့်နံပါတ်ကို အတည်ပြုပါ",
    "otpSentTo": "6 လုံးကုဒ်ကို {{phone}} သို့ WhatsApp ဖြင့် ပေးပို့ပြီးပါပြီ",
    "enterFullCode": "6 လုံးကုဒ်အားလုံး ထည့်ပါ",
    "invalidOtp": "ကုဒ်မမှန်ပါ။ ထပ်မံကြိုးစားပါ။",
    "otpFailed": "ကုဒ်ပို့ရန် မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။",
    "otpResent": "ကုဒ်ကို ထပ်ပို့ပြီးပါပြီ",
    "resendIn": "{{seconds}} စက္ကန့်အတွင်း ထပ်ပို့မည်",
    "resendCode": "ကုဒ်ထပ်ပို့မည်",
    "enterOtp": "WhatsApp သို့ ပေးပို့ထားသောကုဒ် ထည့်ပါ",
    "verify": "အတည်ပြုမည်",
    "resend": "ကုဒ်ထပ်ပို့မည်",
    "wrongNumber": "နံပါတ်မှားနေပါသလား?",
    "backToPhone": "ဖုန်းသို့ ပြန်သွားမည်",
    "editPhone": "ဖုန်းနံပါတ် ပြင်ဆင်မည်",
    "error": "အမှား",
    "setupTitle": "စတင်ပြင်ဆင်ကြမယ်",
    "setupSubtitle": "ဤအရာများကို နောက်မှ ဆက်လက်ပြင်ဆင်နိုင်သည်",
    "namePlaceholder": "သင့်နာမည်",
    "letsGo": "ပြင်ဆင်မှု ပြီးမြောက်မည်",
    "skipForNow": "ယခုအချိန်တွင် ကျော်သွားမည်"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "စာတိုက်ပါ...",
    "inputPlaceholder": "စာတိုက်ပါ...",
    "typing": "FishMemory ရေးနေသည်...",
    "online": "အွန်လိုင်း",
    "connecting": "ချိတ်ဆက်နေသည်...",
    "reconnecting": "ပြန်လည်ချိတ်ဆက်နေသည်...",
    "offline": "အော့ဖ်လိုင်း",
    "empty": "စကားပြောစတင်ပါ",
    "emptyHint": "မှတ်တမ်းများ ဖန်တီး၊ အချိန်ဇယား ကြည့်ရှု၊ ကူညီမှု မေးမြန်းပါ။",
    "emptyAction": "နမူနာမှတ်တမ်း ပို့ပါ",
    "actions": "စကားပြော လုပ်ဆောင်ချက်များ",
    "keep": "စာတိုက်များ ထိန်းသိမ်းမည်",
    "clearTitle": "စာတိုက် ဖျက်မည်",
    "clearConfirm": "ဒီစက်ကိရိယာမှ စာတိုက်အားလုံး ဖျက်မည်လား? ပြန်လည်မရနိုင်ပါ။",
    "clear": "စာတိုက် ဖျက်မည်",
    "optionSelected": "ရွေးချယ်ပြီး: {{label}}",
    "sendingSelection": "ပို့နေသည်...",
    "connectionLost": "ပြန်လည်ချိတ်ဆက်နေသည်..."
  },
  "reminders": {
    "title": "ငါ့မှတ်တမ်းများ",
    "active": "လှုပ်ရှားနေသည်",
    "today": "ယနေ့",
    "thisWeek": "ဒီအပတ်",
    "history": "မှတ်တမ်း",
    "items": "ပစ္စည်းများ",
    "emptyTitle": "မှတ်တမ်း မရှိသေးပါ",
    "emptySubtitle": "စကားပြောမှ ဖန်တီးပါ၊ ဒီမှာ ပြသပါမည်။",
    "emptyAction": "စကားပြော ဖွင့်ပါ",
    "filterActive": "လှုပ်ရှားနေသည်",
    "filterToday": "ယနေ့",
    "filterWeek": "ဒီအပတ်",
    "filterHistory": "မှတ်တမ်း",
    "emptyState": "မှတ်တမ်း မရှိသေးပါ။ စကားပြောစတင်ပါ!",
    "swipeDone": "ပြီးပြီ",
    "swipeSnooze": "နားထားမည်",
    "swipeDelete": "ဖျက်မည်",
    "search": "မှတ်တမ်းများ ရှာဖွေပါ...",
    "upcoming": "လာမည့်",
    "completed": "ပြီးဆုံး",
    "overdue": "ကျော်လွန်",
    "tomorrow": "မနက်ဖြန်",
    "synced": "ချိတ်ဆက်ပြီး {{value}}",
    "swipeHint": "မှတ်တမ်းကို ဆွဲပြီး လုပ်ဆောင်ချက်များ ကြည့်ပါ",
    "noResults": "ရှာဖွေမှုနှင့် ကိုက်ညီသော မှတ်တမ်း မရှိပါ",
    "noResultsHint": "အခြား စကားလုံးများ စမ်းကြည့်ပါ သို့မဟုတ် ရှာဖွေမှု ဖယ်ရှားပါ",
    "deleteAllFailed": "မှတ်တမ်းအားလုံး ဖျက်ရန် မအောင်မြင်ပါ"
  },
  "calendar": {
    "title": "ပြက္ခဒိန်",
    "today": "ယနေ့",
    "tomorrow": "မနက်ဖြန်",
    "completed": "ပြီးပြီ",
    "noEvents": "အစီအစဉ် မရှိပါ",
    "noEventsSubtitle": "နေ့စွဲ ရွေးပြီး မှတ်တမ်းများနှင့် ပြက္ခဒိန် အစီအစဉ်များ ကြည့်ရှုပါ။",
    "googleEvent": "Google Calendar",
    "legendActive": "လှုပ်ရှားနေသည်",
    "legendRecurring": "ထပ်တလဲလဲ",
    "legendDone": "ပြီးပြီ",
    "legendGoogle": "Google",
    "previousMonth": "လွန်ခဲ့သောလ",
    "nextMonth": "လာမည့်လ",
    "previousYear": "လွန်ခဲ့သောနှစ်",
    "nextYear": "လာမည့်နှစ်",
    "goToToday": "ယနေ့သို့ သွားမည်",
    "all": "အားလုံး",
    "active": "လှုပ်ရှားနေသည်",
    "done": "ပြီးပြီ",
    "paused": "နားထားသည်"
  },
  "settings": {
    "title": "ဆက်တင်များ",
    "profile": "ကိုယ်ရေးအချက်အလက်",
    "name": "ပြသမည့်နာမည်",
    "enterName": "နာမည်ထည့်ပါ",
    "language": "ဘာသာစကား",
    "uiLanguage": "အက်ပ်ဘာသာစကား",
    "uiLanguageHelp": "ဒီစက်ပေါ်မှာ အက်ပ် UI၊ ပြက္ခဒိန်တံဆိပ်များနှင့် အစီအစဉ် ဦးတည်ချက် ပြောင်းလဲသည်။",
    "serverLanguage": "စကားပြောဘာသာစကား",
    "serverLanguageHelp": "သင့်အကောင့်အတွက် ဆာဗာဖြေကြားချက်များနှင့် မှတ်တမ်းစာများ ဘာသာစကား ပြောင်းလဲသည်။",
    "timezone": "အချိန်ဇုန်",
    "currentTimezone": "လက်ရှိအချိန်ဇုန်",
    "timezoneHelp": "မှတ်တမ်းအချိန်အားလုံးကို ဒီအချိန်ဇုန်ဖြင့် ပြသသည်။",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "အချိန်ဇုန် သိမ်းမည်",
    "timezoneSaved": "အချိန်ဇုန် ပြင်ဆင်ပြီး",
    "detect": "ရှာဖွေမည်",
    "detectFailed": "အချိန်ဇုန် ရှာမတွေ့ပါ",
    "autoDetect": "GPS မှ အလိုအလျောက် ရှာဖွေမည်",
    "notifications": "အသိပေးချက်များ",
    "notificationsHelp": "နောက်ဆက်တွဲ မှတ်တမ်းများသည် မှတ်တမ်းပေးပို့ပြီးနောက် ထပ်မံအသိပေးချက်များကို ထိန်းချုပ်သည်။ စက်အဆင့် အသိပေးခွင့်များကို ဖုန်းဆက်တင်များတွင် စီမံထားသည်။",
    "pushEnabled": "Push အသိပေးချက်များ",
    "autoDoneOnFire": "ဖွင့်ချိန်တွင် အလိုအလျောက် ပြီးပြီ သတ်မှတ်မည်",
    "autoDoneOnFireDesc": "ပိတ်ထားပါက မှတ်တမ်းများကို သင် ပြီးပြီ ဟု သတ်မှတ်သည်အထိ လှုပ်ရှားနေသည်။",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "ချိတ်ဆက်ပြီး",
    "googleDisconnected": "မချိတ်ဆက်သေးပါ",
    "googleConnectedHelp": "မှတ်တမ်းအသစ်များကို အလိုအလျောက် ပြက္ခဒိန်နှင့်ချိတ်ဆက်နိုင်သည်။",
    "googleDisconnectedHelp": "မှတ်တမ်းများနှင့် အစီအစဉ်များကို ကိုက်ညီစေရန် Google Calendar ချိတ်ဆက်ပါ။",
    "googleConnectFailed": "Google Calendar ချိတ်ဆက်ရန် မအောင်မြင်ပါ",
    "connected": "ချိတ်ဆက်ပြီး",
    "disconnected": "မချိတ်ဆက်သေးပါ",
    "connect": "ချိတ်ဆက်မည်",
    "disconnect": "ချိတ်ဆက်မှု ဖြုတ်မည်",
    "autoSync": "မှတ်တမ်းအသစ်များကို အလိုအလျောက်ချိတ်ဆက်မည်",
    "autosync": "မှတ်တမ်းအသစ်များကို အလိုအလျောက်ချိတ်ဆက်မည်",
    "subscription": "စာရင်းသွင်းမှု",
    "trialUsed": "စမ်းသပ်မှု: {{used}}/{{total}} အသုံးပြုပြီး",
    "trialStatus": "စမ်းသပ်မှု ရရှိနိုင်သည်",
    "activeStatus": "စာရင်းသွင်းမှု လှုပ်ရှားနေသည်",
    "expiredStatus": "စာရင်းသွင်းမှု သက်တမ်းကုန်ဆုံးသည်",
    "unsubscribedStatus": "စာရင်းသွင်းမှု မရှိပါ",
    "about": "အကြောင်း",
    "version": "ဗားရှင်း",
    "logout": "ထွက်မည်",
    "logoutTitle": "ထွက်မည်",
    "logoutConfirm": "ထွက်ရန် သေချာပါသလား?",
    "noName": "နာမည် မရှိသေးပါ",
    "serverConnection": "ဆာဗာ ချိတ်ဆက်မှု",
    "serverUrl": "ဆာဗာ URL",
    "serverEdit": "ပြင်ဆင်မည်",
    "saveReconnect": "သိမ်းပြီး ပြန်ချိတ်ဆက်မည်",
    "resetDefault": "ပုံမှန်သို့ ပြန်လည်သတ်မှတ်မည်",
    "invalidServerUrlTitle": "ဆာဗာ URL မမှန်ကန်ပါ",
    "invalidServerUrlMessage": "မှန်ကန်သော http သို့မဟုတ် https ဆာဗာ URL ထည့်ပါ၊ ဥပမာ https://example.com",
    "uiLanguageChangeFailed": "အက်ပ်ဘာသာစကား ပြောင်းလဲရန် မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။",
    "serverLanguageChangeFailed": "စကားပြောဘာသာစကား ပြောင်းလဲရန် မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။",
    "timezoneChangeFailed": "အချိန်ဇုန် ပြောင်းလဲရန် မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။",
    "autoSyncChangeFailed": "အလိုအလျောက်ချိတ်ဆက်မှု ပြင်ဆင်ရန် မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။",
    "nameChangeFailed": "ပြသမည့်နာမည် ပြင်ဆင်ရန် မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "မှတ်တမ်းအသေးစိတ်",
    "editTime": "အချိန် ပြင်ဆင်မည်",
    "rename": "နာမည်ပြောင်းမည်",
    "snooze": "နားထားမည်",
    "snooze15": "မိနစ် ၁၅ နားထားမည်",
    "pause": "နားထားမည်",
    "pauseReminder": "မှတ်တမ်း နားထားမည်",
    "resume": "ပြန်စတင်မည်",
    "resumeReminder": "မှတ်တမ်း ပြန်စတင်မည်",
    "skip": "နောက်တစ်ကြိမ် ကျော်မည်",
    "skipOccurrence": "ဒီကြိမ် ကျော်မည်",
    "syncGoogle": "Google နှင့်ချိတ်ဆက်မည်",
    "delete": "ဖျက်မည်",
    "deleteTitle": "မှတ်တမ်း ဖျက်မည်",
    "deleteConfirm": "ဒီမှတ်တမ်းကို အမြဲတမ်း ဖျက်မည်။",
    "deleteRecurringTitle": "ထပ်တလဲလဲ မှတ်တမ်း ဖျက်မည်",
    "deleteRecurringMessage": "ဒီကြိမ် ကျော်မလား ဒါမှမဟုတ် စီးရီးအားလုံး ဖျက်မလား?",
    "deleteThisOccurrence": "ဒီကြိမ် ကျော်မည်",
    "deleteEntireSeries": "စီးရီးအားလုံး ဖျက်မည်",
    "done": "ပြီးပြီ",
    "markDone": "ပြီးပြီ ဟု သတ်မှတ်မည်",
    "undo": "ပြန်လည်ဖော်ထုတ်မည်",
    "undoPrompt": "ထပ်မံ လှုပ်ရှားနေစေလိုပါသလား? ယခု ပြန်လည်ဖော်ထုတ်ပါ။",
    "recurring": "ထပ်တလဲလဲ",
    "nextRun": "နောက်တစ်ကြိမ် လည်ပတ်မည်",
    "oneTime": "တစ်ကြိမ်သာ",
    "pending": "စောင့်ဆိုင်းနေသည်",
    "sent": "ပို့ပြီး",
    "paused": "နားထားသည်",
    "active": "လှုပ်ရှားနေသည်",
    "snoozed": "နားထားပြီး",
    "localTime": "သင့်ဒေသအချိန်ဖြင့် ပြသသည်",
    "recurrence": "ထပ်တလဲလဲမှု",
    "created": "ဖန်တီးပြီး",
    "tags": "တံဆိပ်များ",
    "fireCount": "ဖွင့်ခဲ့သောအကြိမ်",
    "actions": "လုပ်ဆောင်ချက်များ",
    "none": "မရှိပါ",
    "snoozeFailed": "မှတ်တမ်း နားထားရန် မအောင်မြင်ပါ",
    "pauseFailed": "မှတ်တမ်း နားထားရန် မအောင်မြင်ပါ",
    "resumeFailed": "မှတ်တမ်း ပြန်စတင်ရန် မအောင်မြင်ပါ",
    "skipFailed": "မှတ်တမ်း ကျော်ရန် မအောင်မြင်ပါ",
    "doneFailed": "မှတ်တမ်း ပြီးပြီ ဟု သတ်မှတ်ရန် မအောင်မြင်ပါ",
    "undoFailed": "မှတ်တမ်း အခြေအနေ ပြန်လည်ဖော်ထုတ်ရန် မအောင်မြင်ပါ",
    "deleteFailed": "မှတ်တမ်း ဖျက်ရန် မအောင်မြင်ပါ",
    "rescheduleTitle": "ပြန်စီစဉ်မလား?",
    "rescheduleMsg": "ဒီမှတ်တမ်း ကျော်လွန်နေပါသည်။ ပြန်စီစဉ်ချင်ပါသလား?",
    "reschedule15": "မိနစ် ၁၅ အတွင်း",
    "reschedule60": "နာရီ ၁ အတွင်း",
    "keepOverdue": "အတိုင်းထားမည်"
  },
  "onboarding": {
    "slide1Title": "FishMemory သို့ ကြိုဆိုပါသည်",
    "slide1Sub": "သင့်ကိုယ်ပိုင် မှတ်တမ်းအကူအညီ — WhatsApp ဖြင့် အားဖြည့်ပြီး သင့်အိတ်အတွက် တည်ဆောက်ထားသည်။",
    "slide2Title": "သဘာဝကျစွာ စကားပြောပါ",
    "slide2Sub": "\"မနက်ဖြန် ၃ နာရီမှာ မေမေကို ဖုန်းခေါ်ဖို့ မှတ်ပေးပါ\" လို ရိုက်ထည့်ပါ — ကျွန်ုပ်တို့က ကျန်တာကို စီမံပေးပါမည်။",
    "slide3Title": "အရာအားလုံး မလွတ်မသွားပါ",
    "slide3Sub": "အချိန်မီ အသိပေးချက်များ ရယူပါ၊ တံဆိပ်များဖြင့် စီမံပါ၊ အရေးကြီးသော အရာအားလုံးကို ထိန်းသိမ်းပါ။",
    "getStarted": "စတင်မည်",
    "next": "နောက်တစ်ခု",
    "firstReminderTitle": "သင့် ပထမဆုံး မှတ်တမ်း ဖန်တီးပါ!",
    "firstReminderHint": "အောက်ပါအတိုင်း ရိုက်ထည့်ကြည့်ပါ:",
    "firstReminderExample": "မနက်ဖြန် ၉ နာရီမှာ ရေသောက်ဖို့ မှတ်ပေးပါ",
    "gotIt": "နားလည်ပါပြီ!",
    "notifRationaleTitle": "အချိန်မီ ရှိနေပါ",
    "notifRationaleBody": "FishMemory သည် သင့်အား အချိန်မီ သတိပေးရန် အသိပေးချက်များ လိုအပ်သည်။ သင်ဖန်တီးသော မှတ်တမ်းများအတွက်သာ အသိပေးချက်များ ရရှိမည်ဖြစ်သည်။",
    "notifRationaleAllow": "အသိပေးချက် ဖွင့်ပါ",
    "notifRationaleLater": "နောက်မှဖြစ်နိုင်သည်",
    "swipeHint": "အမြန် လုပ်ဆောင်ချက်များအတွက် ညာဘက်သို့ ဆွဲပါ →",
    "calendarDragHint": "ချဲ့ရန် ဆွဲပါ ↕"
  }
}
